var _a;
import { ADD_QUESTION_TYPE, QUESTION_TYPE } from "../enum/ai-question";
var FREE = ADD_QUESTION_TYPE.FREE, LANGUAGE = ADD_QUESTION_TYPE.LANGUAGE, EVALUATION = ADD_QUESTION_TYPE.EVALUATION, SINGLECHIOCE = ADD_QUESTION_TYPE.SINGLECHIOCE;
var QA = QUESTION_TYPE.QA, COLOR_BLINDNESS = QUESTION_TYPE.COLOR_BLINDNESS, ALPHABETIC_DICTATION = QUESTION_TYPE.ALPHABETIC_DICTATION, AI_ANALYSIS = QUESTION_TYPE.AI_ANALYSIS, POLICY_DECISION_GAME = QUESTION_TYPE.POLICY_DECISION_GAME, MEMORY_GAME = QUESTION_TYPE.MEMORY_GAME, EMOTION_GAME = QUESTION_TYPE.EMOTION_GAME;
/*
 * 题目类型列表
 */
export var ADD_QUESTION_TYPE_LIST = [
    {
        type: FREE,
        hide: false,
        title: '问答题',
        desc: '以问答的形式要求候选人对你定问题作答。',
    },
    {
        type: LANGUAGE,
        hide: false,
        title: '朗读题',
        desc: '候选人根据所提供的文案进行朗读。',
    },
    {
        type: EVALUATION,
        hide: true,
        title: '评测题',
        desc: '候选人根据所提供的文案进行朗读。',
    },
    {
        type: SINGLECHIOCE,
        hide: false,
        title: '单选题',
        desc: '以单选的形式要求候选人对问题进行作答。',
    },
];
/*
 * 可以自定义的题目类型列表
 */
export var ADD_QUESTION_TYPE_SHOW_LIST = ADD_QUESTION_TYPE_LIST.filter(function (v) { return !v.hide; });
/*
 * 题目类型名称映射表
 */
export var QUESTION_TYPE_TITLE_MAP = ADD_QUESTION_TYPE_LIST.reduce(function (acc, cur) {
    acc[cur.type] = cur.title;
    return acc;
}, {});
export var QUESTION_TYPE_MAPPING_LABEL = (_a = {},
    _a[QA] = '问答题',
    _a[COLOR_BLINDNESS] = '色盲题',
    _a[ALPHABETIC_DICTATION] = '字母听写题',
    _a[AI_ANALYSIS] = 'AI分析题',
    _a[POLICY_DECISION_GAME] = '决策能力-游戏题',
    _a[MEMORY_GAME] = '短期记忆-游戏题',
    _a[EMOTION_GAME] = '情绪判断-游戏题',
    _a);
export var DEFAULT_GUIDE_VIDEO_URL = 'https://alicdn.fbmms.cn/CPAL19KVV5RR06ISK1L0.mp4';
export var DEFAULT_GUIDE_VIDEO_THUMB_URL = 'https://alicdn.fbmms.cn/CPAL19KVV5RR06ISK1L0.mp4?x-oss-process=video/snapshot,t_0,f_jpg';
export var DEFAULT_GUIDE_VIDEO = [
    {
        videoUrl: DEFAULT_GUIDE_VIDEO_URL,
        frameUrl: DEFAULT_GUIDE_VIDEO_THUMB_URL,
        loading: false,
    },
];
export var DEFAULT_PC_GUIDE_VIDEO_URL = 'https://alicdn.fbmms.cn/CPAL19KVV5RR06ISK1L0.mp4';
export var DEFAULT_PC_GUIDE_VIDEO_THUMB_URL = 'https://alicdn.fbmms.cn/CPAL19KVV5RR06ISK1L0.mp4?x-oss-process=video/snapshot,t_0,f_jpg';
export var DEFAULT_PC_GUIDE_VIDEO = [
    {
        videoUrl: DEFAULT_PC_GUIDE_VIDEO_URL,
        frameUrl: DEFAULT_PC_GUIDE_VIDEO_THUMB_URL,
        loading: false,
    },
];
export var DEFAULT_VITUAL_HUMAN_LIST = [
// {
//   name: 'xuanxuan', // 虚拟人名字
//   humanToken: '71c932a2db9e420ab8782d68861ad0ff', // 数智虚拟人token
//   humanType: 2, // 类型 1： 小面 2：虚拟人
//   virtualHumanAvatar: 'https://alicdn.fbmms.cn/virtual-human-20230720-112709.png',
//   virtualPreviewMedia: 'https://demo1-landing-page.oss-cn-beijing.aliyuncs.com/d5bcc15e-f42f-4bad-bde9-2d6c300bf9ca.mp4',
// },
];
export var InteractiveModes = {
    1: '传统读题模式',
    2: 'AI面试官对话模式',
};
export var AiVideoStatus = {
    0: '播报视频生成中...',
    1: '播报视频生成中...',
    2: '播报视频已生成',
    3: '播报视频生成中...',
};
export var MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 20;
export var MAX_UPLOAD_VIDEO_FILE_SIZE = 1024 * 1024 * 500;
export var TEST_TYPE_READONLY = [2, 3, 4, 7, 8, 9, 10, 11, 12, 16];
export var DISABLED_REPEAT_TYPE = [2, 4, 7, 8, 9, 11, 12, 16, 17];
export var DISABLED_COST_TYPE = [7, 9, 8, 4, 11, 2, 16];
// 是否开启AI分析
export var IS_AI_ANALYSIS = function (step) { return step.aiType === 2; };
// 是否可以追问
export var IS_AI_FOLLOW_UP = function (step, interaction) {
    return step.aiShowType === 1 && (step.broadcastType === 2 || !IS_VIRTUAL_HUMAN(interaction));
};
var IS_VIRTUAL_HUMAN = function (interaction) {
    if (interaction.length === 0)
        return false;
    return interaction.some(function (v) { var _a; return v.selected && (v.type === 2 || (v.type === 3 && ((_a = v.detail.interviewerShows) === null || _a === void 0 ? void 0 : _a.some(function (v) { return v.selected && v.humanType === 2; }))) || false); });
};
export var MAX_RANDOM_QUESTION_NUM = 50;
